import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = ["value", "disabled", "required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['block', $setup.wrapperClass])
  }, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("select", _mergeProps({
      value: $props.modelValue,
      disabled: $props.disabled,
      required: $props.required,
      class: "field"
    }, $setup.selectAttrs, {
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onChange && $setup.onChange(...args)))
    }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16, _hoisted_2)
  ], 2))
}